import { App_Url } from "@/whiteLable";
const CurrencySymbol = ({ currency, value }) => {
  // console.log("CurrencySymbol::", { currency, value });
  const isNumeric =
    (typeof value === "number" && !isNaN(value)) ||
    (typeof value === "string" && /^[+-]?\d+(\.\d+)?$/.test(value.trim()));
  if (!currency || !isNumeric) return null;

  if (currency.toUpperCase() === "AED") {
    return <img src={App_Url.partners.symbols.Aed} alt="AED" className="h-3 w-auto inline-block" />;
  } else if (currency.toUpperCase() === "USD") {
    return <p>$</p>;
  } else if (currency.toUpperCase() === "EUR") {
    return <p>€</p>;
  }

  return <span className="">{currency}</span>;
};

export default CurrencySymbol;
